import { toast } from 'react-toastify';

export function errorToast(msg: string) {
	// add ellipses if string exceeds 200 characters
	const concatMsg = msg.length > 100 ? msg.slice(0, 200) + '...' : msg;
	toast.error(concatMsg, {
		position: toast.POSITION.TOP_CENTER,
		className: 'toast-container toast-error',
	});
}

export function successToast(msg: string) {
	toast.success(msg, {
		position: toast.POSITION.TOP_CENTER,
		className: 'toast-container toast-success',
	});
}

export function infoToast(msg: string) {
	toast.info(msg, {
		position: toast.POSITION.TOP_CENTER,
		className: 'toast-container toast-info',
	});
}

export function warningToast(msg: string) {
	toast.warn(msg, {
		position: toast.POSITION.TOP_CENTER,
		className: 'toast-container toast-warn',
	});
}
